/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Toast_Cancel_PlhInputs */

const vi_pkl_toast_cancel_plh = /** @type {(inputs: Pkl_Toast_Cancel_PlhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã hủy phiếu lấy hàng`)
};

/**

* @param {Pkl_Toast_Cancel_PlhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_toast_cancel_plh = /** @type {((inputs?: Pkl_Toast_Cancel_PlhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Toast_Cancel_PlhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_toast_cancel_plh(inputs)
});